/**
 * Serviço de Procedimentos
 * Comunicação com API de procedimentos
 */

import api from './api';

const procedimentoService = {
  // Listar todos os procedimentos
  listar: async () => {
    const response = await api.get('/procedimentos');
    return response; // Interceptor já retorna response.data
  },

  // Buscar procedimento por ID
  buscarPorId: async (id) => {
    const response = await api.get(`/procedimentos/${id}`);
    return response; // Interceptor já retorna response.data
  },

  // Criar novo procedimento
  criar: async (dados) => {
    const response = await api.post('/procedimentos', dados);
    return response; // Interceptor já retorna response.data
  },

  // Atualizar procedimento
  atualizar: async (id, dados) => {
    const response = await api.put(`/procedimentos/${id}`, dados);
    return response; // Interceptor já retorna response.data
  },

  // Deletar procedimento
  deletar: async (id) => {
    const response = await api.delete(`/procedimentos/${id}`);
    return response; // Interceptor já retorna response.data
  },

  // Buscar procedimentos (para autocomplete)
  buscar: async (termo = '') => {
    const response = await api.get('/procedimentos/buscar', {
      params: { termo }
    });
    return response; // Interceptor já retorna response.data
  }
};

export default procedimentoService;
